import type {
  TaxonImageResponseDto,
  TaxonWithConfidenceDto,
} from '@/api/TaxonomyApi/generated/model';

export interface SpeciesAiMatchResult {
  bestMatch: TaxonWithConfidenceDto | null;
  otherMatches: TaxonWithConfidenceDto[];
}

export const normalizeMatchResponse = (
  response: TaxonImageResponseDto,
): SpeciesAiMatchResult => {
  const sortedMatches = [...response.taxons].sort(
    (left, right) => right.confidence - left.confidence,
  );

  return {
    bestMatch: sortedMatches[0] ?? null,
    otherMatches: sortedMatches.slice(1),
  };
};

export const formatConfidence = (confidence: number): string =>
  `${Math.round(confidence * 100)}%`;
